import { validationMessage } from 'vuelidate-messages'
import { required } from 'vuelidate/lib/validators'
import { messages } from '@/lib/validation-helpers'

export const validations = {
  validations() {
    return {
      form: {
        ip_address: { required },
        provider_id: { required }
      }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages),
    $v_validationPass() {
      this.$v.$touch()
      return !this.$v.$invalid
    }
  }
}
